import { CURSOR_BAR_WIDTH } from "@/components/panels/input-bar-metrics";

/**
 * Compute viewport coordinates for the comment popover so it appears
 * next to a clicked element (typically a comment-anchor badge inside
 * a markdown frame), with viewport-edge clamping so it never goes
 * off-screen.
 *
 * Strategy: try to place the popover to the right of the anchor; fall
 * back to the left if there is no room. Vertically, align the popover
 * top with the anchor top, then clamp inside the viewport.
 */

const POPOVER_WIDTH = CURSOR_BAR_WIDTH;
const POPOVER_MAX_HEIGHT = 480;
const MARGIN = 8;

export function anchorPositionFor(el: HTMLElement): { x: number; y: number } {
  const rect = el.getBoundingClientRect();

  let x = rect.right + MARGIN;
  if (x + POPOVER_WIDTH > window.innerWidth - MARGIN) {
    x = Math.max(MARGIN, rect.left - POPOVER_WIDTH - MARGIN);
  }

  let y = rect.top;
  if (y + POPOVER_MAX_HEIGHT > window.innerHeight - MARGIN) {
    y = Math.max(MARGIN, window.innerHeight - POPOVER_MAX_HEIGHT - MARGIN);
  }

  return { x, y };
}
